module.exports = {
  DRAFT: { api: 'DRAFT', human: 'Entwurf' },
  PUBLISHED: { api: 'PUBLISHED', human: 'Veröffentlicht' }
}
